import { SPORTS, LEVELS } from "@/lib/games";

const WHEN = [
  { k: "hoje", label: "Hoje" },
  { k: "amanha", label: "Amanhã" },
  { k: "fds", label: "Fim de semana" },
];

const TYPES = [
  { k: "churrasco", label: "🔥 Churras" },
  { k: "resenha", label: "🍻 Resenha" },
  { k: "festa", label: "🎉 Festa" },
  { k: "atletica", label: "🏆 Atlética" },
  { k: "luau", label: "🌙 Luau" },
  { k: "show", label: "🎸 Show" },
  { k: "feira", label: "🛍️ Feira" },
  { k: "outro", label: "📍 Outro" },
];

const LAYERS = [
  { k: "all", label: "Tudo" },
  { k: "events", label: "Eventos" },
  { k: "games", label: "Esportes" },
  { k: "adegas", label: "Adegas" },
];

const Sep = () => <span className="w-px bg-white/10 mx-1 shrink-0" />;

export default function Filters({ value, onChange, layer = "all", onLayer }) {
  const chip = (field, k, label, testid) => {
    const active = value[field] === k;
    return (
      <button key={`${field}-${k}`} onClick={() => onChange({ ...value, [field]: active ? null : k })} data-testid={testid}
        className={`press shrink-0 whitespace-nowrap px-3.5 h-9 rounded-full text-sm font-medium border ${active ? "bg-primary text-primary-foreground border-primary" : "bg-black/40 text-foreground border-white/10"}`}>
        {label}
      </button>
    );
  };

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-4 gap-1 p-1 rounded-full bg-black/40 border border-white/10" data-testid="layer-filter">
        {LAYERS.map((l) => (
          <button key={l.k} onClick={() => onLayer?.(l.k)} data-testid={`layer-${l.k}`}
            className={`press h-8 rounded-full text-[13px] font-semibold transition-colors ${layer === l.k ? "bg-primary text-primary-foreground" : "text-muted-foreground"}`}>
            {l.label}
          </button>
        ))}
      </div>
      {layer !== "adegas" && (
        <div className="flex gap-2 overflow-x-auto scrollbar-none" data-testid="filters-row">
          {WHEN.map((w) => chip("when", w.k, w.label, `filter-when-${w.k}`))}
          {layer === "games" ? (
            <>
              <Sep />
              {LEVELS.map((l) => chip("level", l.k, l.label, `filter-level-${l.k}`))}
              <Sep />
              {SPORTS.map((s) => chip("sport", s.k, `${s.icon} ${s.label}`, `filter-sport-${s.k}`))}
            </>
          ) : (
            <>
              <Sep />
              {TYPES.map((t) => chip("type", t.k, t.label, `filter-type-${t.k}`))}
            </>
          )}
        </div>
      )}
    </div>
  );
}
